import { createAsyncThunk } from '@reduxjs/toolkit';
import request from '../../request/request';

export const getGlobalCheckpoints = createAsyncThunk(
  'getGlobalCheckpoints',
  async (_, { rejectWithValue }) => {
    try {
      const response = await request('/api/v1/tenants/unique-checkpoints', {
        method: 'GET',
        auth: true,
      });

      if (response?.data) {
        return response;
      }

      return rejectWithValue(response?.error || 'Something went wrong');
    } catch (error) {
      return rejectWithValue(error?.message || 'Something went wrong');
    }
  }
);
